export default __webpack_public_path__ + "static/media/Gellix-BoldItalic.b80d4133.woff";